import { Button, Flex, Input, Modal } from "antd";
import * as React from "react";

import * as styles from "./QueryBuilderDescriptionModal.module.less";

type PropsQueryBuilderDescriptionModal = {
  open: boolean;
  description: string;
  onChange: (value: string) => void;
  onCancel: () => void;
  onContinue: () => void;
};

export const QueryBuilderDescriptionModal: React.FC<
  PropsQueryBuilderDescriptionModal
> = ({ open, description, onChange, onCancel, onContinue }) => (
  <Modal
    title="Добавление описания к шаблону"
    open={open}
    onCancel={onCancel}
    width={640}
    footer={
      <Flex justify="flex-end" gap={8}>
        <Button onClick={onCancel}>Отменить</Button>
        <Button type="primary" onClick={onContinue}>
          Продолжить
        </Button>
      </Flex>
    }
  >
    <Flex vertical gap={8}>
      <div className={styles.sectionTitle}>Описание</div>
      <Input.TextArea
        value={description}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Введите описание"
        autoSize={{ minRows: 2, maxRows: 4 }}
      />
    </Flex>
  </Modal>
);
